module.exports = __webpack_public_path__ + "img/jbitraining_card_img.b50686d0.png";